<script lang="ts" setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import type { FormFieldType, FormFieldSubType } from "~/models/FormField";
import formFields, { type FormFieldTypeMap } from "~/stores/forms/form-fields";

type FieldTypes = FormFieldType | FormFieldSubType | "unknown";

const props = withDefaults(
    defineProps<{
        variant?: "badge" | "icon";
        type?: FieldTypes;
        subType?: FormFieldSubType;
        label?: string;
        iconOnly?: boolean;
        spin?: boolean;
        color?: string;
        badgeSize?: string;
        iconSize?: string;
    }>(),
    {
        variant: "icon",
    },
);

const fieldType = computed((): FormFieldTypeMap => {
    const sub_type = props.subType ? formFields.find(props.subType) : null;

    if (sub_type) {
        return sub_type;
    }

    const type = props.type ? formFields.find(props.type) : null;

    if (type) {
        return type;
    }

    return formFields.find("unknown");
});
</script>

<template>
    <UBadge
        v-if="variant === 'badge'"
        class="flex gap-2"
        :class="fieldType.theme.background"
        :size="badgeSize"
    >
        <FontAwesomeIcon
            :icon="fieldType.icon"
            :class="color ?? fieldType.theme.foreground"
            :spin="spin"
            fixed-width
            :size="iconSize"
        />
        <span :class="color ?? fieldType.theme.foreground">{{ label }}</span>
    </UBadge>
    <FontAwesomeIcon
        v-else-if="iconOnly || !props.label"
        :icon="fieldType.icon"
        :class="color ?? fieldType.theme.icon"
        :spin="spin"
        fixed-width
        :size="iconSize"
    />
    <div v-else class="flex items-center gap-2">
        <FontAwesomeIcon
            :icon="fieldType.icon"
            :class="color ?? fieldType.theme.icon"
            :spin="spin"
            fixed-width
            :size="iconSize"
        />
        <span v-if="props.label">{{ props.label }}</span>
    </div>
</template>
